import React, { useEffect } from 'react'
import { handleDiscordCallback } from '../auth/discord'

const AuthCallback: React.FC = () => {



  useEffect(() => {
    const run = async () => {
      try {
        await handleDiscordCallback()

        setTimeout(() => {
          window.location.replace('/#account')
        }, 800)
      } catch (e) {
        console.error('Discord callback error:', e)
      }
    }
    run()
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
    </div>
  )
}

export default AuthCallback

